import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { LogoutReasons, login, logout } from 'reducers/userSlice';
import { store } from 'store';
import { authRefresh } from 'utils/auth';

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const jwtToken = store.getState().user.jwtToken;

  if (jwtToken) {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${jwtToken}`,
      },
    };
  }
  return config;
};

let refreshPromise: Promise<void> | null = null;

const refreshSession = (): Promise<void> => {
  if (!refreshPromise) {
    refreshPromise = authRefresh()
      .then((data) => {
        store.dispatch(login(data.jwt));
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
};

type RetriableConfig = AxiosRequestConfig & { _retry?: boolean };

const onResponseError = async (error: AxiosError) => {
  const originalRequest = error.config as RetriableConfig | undefined;

  if (
    error.response?.status === 401 &&
    originalRequest &&
    !originalRequest._retry
  ) {
    originalRequest._retry = true;
    try {
      await refreshSession();
      return axios(originalRequest);
    } catch {
      store.dispatch(logout(LogoutReasons.expired));
    }
  }

  return Promise.reject(error);
};

export function setupInterceptorsTo(
  axiosInstance: AxiosInstance,
): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest);
  axiosInstance.interceptors.response.use(undefined, onResponseError);
  return axiosInstance;
}
